module.exports = __webpack_public_path__ + "img/agriculture.1e4e350e.jpg";